/** 
*@author: Sirisha.M
*@Description : 
**/
import { connect } from 'react-redux';
import React, { useState, useEffect, useRef } from 'react';
import { constant } from '../Utils/constants';
import translation from '../Utils/translation';
import Highlighter from 'react-highlight-words';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import { DrawerFooter } from '../../../commons/styles/layout';
import themeSettings from '../../../commons/styles/themeSettings.json';
import { API_ASSET, API_MASTERCONFIGURATION, IPAddress } from '../../../commons/api';
import {
  Tabs,
  Form,
  Space,
  Input,
  Button,
  Select,
  Drawer,
  Tooltip,
  message,
  Upload
} from 'antd';
import {
  getAttributesList,
  CreateAssetAttribute,
  getAttributesListByAsset,
  getUnCommonFileDownloadName
} from '../APICalls';
import axios from 'axios';
import {
  EditOutlined,
  PlusOutlined,
  SearchOutlined,
  MinusCircleOutlined,
  DownloadOutlined,
  UploadOutlined
} from '@ant-design/icons';

const { Option } = Select;
const { TabPane } = Tabs;

const APIList = {
  createAsset: `/api/asset/assetAttributes/upsert`
};

const AssetAttributeList = (props) => {
  const [dataSource, setDataSource] = useState([]);
  // const [activeKey, setActiveKey] = useState('1');
  const [formObject, setFormObject] = useState({});
  const [searchText, setSearchText] = useState({});
  const [dynamicEditObject, setDynamicEditObject] = useState({});
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  const [AssetList, setAssetList] = useState([]);
  const [TypeList, setTypeList] = useState([]);
  const [visibleParent, setVisibleParent] = useState(false);
  const [fileDownloadName, setFileDownloadName] = useState('');

  const hForm = useRef();
  const searchInput = useRef(null);
  const dynamicConfig = useRef();

  useEffect(() => {
    _getAdhocDataSource();
    getFileDownloadName();
    getAssetList();
    getTypeList();

    // Update translation cache when props change
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }

    // Update user profile when props change
    if (props.userProfile !== userProfile) {
      setUserProfile(props.userProfile);
    }

  }, []);

  const getAssetList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let url = `${API_ASSET.GET}?SiteId=${siteId}`;

    axios.get(url, { headers: { Authorization: `Bearer ${accessToken}` } })
      .then((response) => {
        setAssetList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getTypeList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let url = `${API_MASTERCONFIGURATION.GetDropdownForCompositeKey}?SiteId=${siteId}`;

    axios.post(url, {
      TableName: 'rubusconfig."SM_AssetAttributes"',
      ColumnName: 'Name',
      ColumnValue: 'Code',
      Conditions: [{ key: 'SiteId', value: siteId }]
    }, { headers: { Authorization: `Bearer ${accessToken}` } })
      .then((response) => {
        setTypeList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const _getAdhocDataSource = async () => {
    let dataSource = await getAttributesList();
    setDataSource(dataSource);
    // setActiveKey('1');
    setFormObject({});
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, `Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(props.translationCache, 'Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation(props.translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),

    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });


  const onClose = () => {
    setVisibleParent(false);
    setFormObject({});
    setDynamicEditObject({});
    hForm.current && hForm.current.resetFields();
    dynamicConfig.current && dynamicConfig.current.resetFields();
  };

  const AddNew = () => {
    hForm.current && hForm.current.resetFields();
    dynamicConfig.current && dynamicConfig.current.resetFields();
    setVisibleParent(true);
    setFormObject({});
    setDynamicEditObject({});
  };

  const editAssetMaster = (edit) => {
    let formObjectData = onAssetAliasChange(edit.AssetAlias);
    if (hForm.current) {
      hForm.current.setFieldsValue(formObjectData);
      dynamicConfig.current && dynamicConfig.current.setFieldsValue({ Details: formObjectData.Details });
    }
    setFormObject(formObjectData);
    setVisibleParent(true);
    setDynamicEditObject({ Details: formObjectData.Details });
  };

  const onFinish = async () => {
    let Details = [];
    try {
      dynamicConfig.current && dynamicConfig.current
        .validateFields()
        .then((values) => {
          Details = values && values['Details'] ? values['Details'] : [];
        })
        .catch((error) => {
          console.log(error);
        });
      // Details = await dynamicConfig.current && dynamicConfig.current.validateFields().then(values => values && values['Details'] ? values['Details'] : []);
      hForm.current && hForm.current.validateFields().then(async (values) => {
        let payload = { AssetAlias: values.AssetAlias, Details };

        let CreateResponse = await CreateAssetAttribute(APIList.createAsset, payload);
        if (CreateResponse && CreateResponse.message) {
          message.success(CreateResponse.message);
        }
        await _getAdhocDataSource();
        hForm.current && hForm.current.setFieldsValue({ AssetAlias: '', Details: {} });
        setVisibleParent(false);
        setFormObject({});
        setDynamicEditObject({});
      });
    } catch (error) {
      console.log(error);
    }
  };

  const onAssetAliasChange = async (value) => {
    let list = await getAttributesListByAsset(value);
    let formObjectData = list || {};
    if (hForm.current) {
      hForm.current.setFieldsValue(formObjectData);
      dynamicConfig.current && dynamicConfig.current.setFieldsValue({ Details: formObjectData.Details });
    }
    setFormObject(formObjectData);
    setDynamicEditObject({ Details: formObjectData.Details });
  };

  const getFileDownloadName = async () => {
    let fileDownloadName = await getUnCommonFileDownloadName();
    setFileDownloadName((fileDownloadName && fileDownloadName.file) || '');
  };

  const columns = [
    {
      title: translation(translationCache, constant.AssetAlias),
      dataIndex: 'Name',
      key: 'Name',
      filter: true,
      ...getColumnSearchProps('Name')
    },
    {
      title: translation(translationCache, constant.action),
      width: '600',
      render: (text, record) => (
        <>
          <Button onClick={() => editAssetMaster(record)}>
            <Tooltip title={translation(translationCache, 'Edit')}>
              <EditOutlined />
            </Tooltip>
          </Button>
        </>
      )
    }
  ];

  return (
    <div style={{ minHeight: window.innerHeight - 69 }}>
      <div style={{ display: 'flex', justifyContent: 'right', marginTop: '10px' }}>
        <Button>
          <a href={`${IPAddress.LOCAL}${fileDownloadName}`}>
            <DownloadOutlined style={{ color: 'white', marginRight: '1px' }} />
            <span style={{ color: 'white', marginRight: '10px' }}>
              {translation(translationCache, 'Download')}
            </span>
          </a>
        </Button>
        <Button>
          <Upload
            multiple={false}
            style={{ marginRight: '10px', color: 'white' }}
            onChange={(info) => {
              if (info.file.status === 'done') {
                message.success(info.file.response.message);
                getFileDownloadName();
                _getAdhocDataSource();
              } else if (info.file.status === 'error') {
                message.error(info.file.response.message);
              }
            }}
            action={`/api/upload/assetAttributes?SiteId=${localStorage.get('currentSite')}`}
            headers={{
              Authorization: `Bearer ${localStorage.get('accessToken')}`
            }}
            showUploadList={false}
          >
            <UploadOutlined style={{ color: 'white', marginRight: '1px' }} />
            <span style={{ color: 'white', marginRight: '10px' }}>
              {translation(translationCache, 'Upload')}
            </span>
          </Upload>
        </Button>
        <Button type='primary' onClick={AddNew}>
          <PlusOutlined /> {translation(translationCache, 'Add')}
        </Button>
      </div>
      <Tabs>
        <TabPane>
          <StyledTable size="small"
            columns={columns}
            dataSource={dataSource}
            pagination={
              dataSource && dataSource.length > 10
                ? { pageSize: '10' }
                : false
            }
          />
        </TabPane>
      </Tabs>

      <Drawer
        title={
          formObject && formObject.Id
            ? translation(translationCache, 'Update')
            : translation(translationCache, 'Add')
        }
        placement="right"
        width={600}
        closable
        onClose={onClose}
        open={visibleParent}
      >
        <Form
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 12 }}
          theme={themeSettings}
          layout="horizontal"
          ref={hForm}
          name="Site_form"
          initialValues={formObject || {}}
          onFinish={onFinish}
        >
          <Form.Item
            style={{ width: '100%', flex: '50%', marginTop: '20px' }}
            label={translation(translationCache, constant.asset)}
            name="AssetAlias"
          >
            <Select
              style={{ width: '50%' }}
              value={formObject.AssetAlias}
              placeholder={'Select Asset Alias'}
              onChange={(e) => onAssetAliasChange(e)}
            >
              {AssetList &&
                Array.isArray(AssetList) &&
                AssetList.map((Asset, index) => (
                  <Option key={index} value={Asset.AliasCode}>
                    {Asset.DisplayCode}
                  </Option>
                ))}
            </Select>
          </Form.Item>

          <Form.Item label={'Details'} name="Details" rules={[{ required: false }]}>
            <Form ref={dynamicConfig} name="dynamic_form_nest_item" autoComplete="off" initialValues={dynamicEditObject || {}}>
              <Form.List name="Details">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Space key={key} style={{ display: 'flex', marginBottom: '8px' }} align="baseline">
                        <Form.Item {...restField} name={[name, 'Type']} rules={[{ required: true, message: 'Select Type' }]}>
                          <Select showArrow openOnFocus style={{ width: '200px' }} placeholder={'Type'}>
                            {TypeList &&
                              Array.isArray(TypeList) &&
                              TypeList.map((type, index) => (
                                <Option key={index} value={type.Value}>{type.Key}</Option>))}
                          </Select>
                        </Form.Item>
                        <Form.Item {...restField} name={[name, 'Value']} rules={[{ required: true, message: 'Input Value' }]}>
                          <Input placeholder={'Value'} style={{ width: '200px' }} />
                        </Form.Item>

                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Space>))}
                    <Form.Item>
                      <Button style={{ width: '150px' }} type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                        {'Add'}
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Form>

          </Form.Item>
        </Form>
        <DrawerFooter>
          <Button type="primary" onClick={onClose} style={{ marginRight: '8px' }}>
            {translation(translationCache, 'Cancel')}
          </Button>
          <Button type="primary" onClick={onFinish}>
            {translation(translationCache, 'Submit')}
          </Button>
        </DrawerFooter>

      </Drawer>

    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(AssetAttributeList);

